// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mEb4","left":"styles_left__1UuCb","desktopActions":"styles_desktopActions__EUqD9","title":"styles_title__3W2K3"};